import React from "react";
import { fmtSignedMoney } from "../format";

const SEG_TONES = ["bg-chart-teal", "bg-chart-2", "bg-chart-3", "bg-chart-pred"];
const UNRESOLVED = /shared services|unallocated|unassigned/i;

// Signed stacked bar for one ownership lens: segments sized by |Δ| share, the
// unresolved (Shared/Unallocated) segment rendered in a soft rose so the gap reads.
export default function LensCompositionBar({ rows = [] }) {
  const mat = rows.filter((r) => Math.abs(r.deltaCost || 0) >= 0.005);
  const total = mat.reduce((s, r) => s + Math.abs(r.deltaCost || 0), 0);
  if (!(total > 0)) return null;
  const ranked = [...mat].sort((a, b) => Math.abs(b.deltaCost) - Math.abs(a.deltaCost));
  return (
    <div className="mt-2">
      <div className="flex overflow-hidden rounded-full bg-surface-2" style={{ height: 14, width: "100%" }} role="img" aria-label="Ownership composition">
        {ranked.map((r, i) => {
          const isGap = UNRESOLVED.test(r.label || "");
          const tone = isGap ? "bg-[hsl(347_74%_82%)]" : SEG_TONES[i % SEG_TONES.length];
          return <div key={r.ownerNodeId ?? i} className={tone} style={{ width: `${(Math.abs(r.deltaCost) / total) * 100}%`, height: "100%" }} title={`${r.label}: ${fmtSignedMoney(r.deltaCost)}`} />;
        })}
      </div>
    </div>
  );
}
